// Import markdown files as raw text using Parcel's bundle-text: scheme
// Add new imports here when creating new runbook pages
import gettingStarted from 'bundle-text:./getting-started.md';
import stalledPublish from 'bundle-text:./restart-stalled-publiish-job.md';
import persistentGeofencing from 'bundle-text:./peristent-streams-geofencing.md';
import orphanedEncoders from 'bundle-text:./orphaned-encoders.md';
import duplicateEvents from 'bundle-text:./duplicate-events.md';
import missingMedia from 'bundle-text:./missing-media-investigation.md';
import rtmpVsSrt from 'bundle-text:./rtmp-vs-srt.md';
import setupPersistentStream from 'bundle-text:./setup-persistent-stream.md';
import liveStreamHealth from 'bundle-text:./live-stream-health.md';
import transcodeRunningLong from 'bundle-text:./transcode-running-long.md';
import cancelTranscodeJob from 'bundle-text:./cancel-transcode-job.md';
import githubActionsBudget from 'bundle-text:./github-actions-budget.md';
import stuckUnpublishB2 from 'bundle-text:./stuck-unpublish-b2.md';


/**
 * Notes on Adding New Runbook docs
 *  1. Create the .md file in `src/client/content/runbook/`
 *  2. Add two lines to `src/client/content/runbook/index.ts`:
 *      `import myNewDoc from 'bundle-text:./my-new-doc.md';`
 *  3. And add to the docs array:
 *      `{ slug: 'my-new-doc', content: myNewDoc },`
 */

export interface RunbookPage {
  slug: string;
  title: string;
  content: string;
}

function extractTitle(content: string): string {
  const match = content.match(/^#\s+(.+)$/m);
  return match ? match[1].trim() : 'Untitled';
}

const docs = [
  { slug: 'stalled-publish', content: stalledPublish },
  { slug: 'peristent-stream-geofencing', content: persistentGeofencing },
  { slug: 'orphaned-encoders', content: orphanedEncoders },
  { slug: 'duplicate-events', content: duplicateEvents },
  { slug: 'missing-media', content: missingMedia },
  { slug: 'rtmp-vs-srt', content: rtmpVsSrt },
  { slug: 'setup-persistent-stream', content: setupPersistentStream },
  { slug: 'live-stream-health', content: liveStreamHealth },
  { slug: 'transcode-running-long', content: transcodeRunningLong },
  { slug: 'cancel-transcode-job', content: cancelTranscodeJob },
  { slug: 'github-actions-budget', content: githubActionsBudget },
  { slug: 'stuck-unpublish-b2', content: stuckUnpublishB2 },
];

export const runbookPages: RunbookPage[] = docs
  .map(({ slug, content }) => ({
    slug,
    title: extractTitle(content),
    content,
  }))
  // .sort((a, b) => a.title.localeCompare(b.title));

export const runbookBySlug: Record<string, RunbookPage> = Object.fromEntries(
  runbookPages.map((page) => [page.slug, page])
);
